export const aspect : number= 7.7;